// extracted by mini-css-extract-plugin
module.exports = {"s1x6xrh0":"s1x6xrh0","wrjvada":"wrjvada"};